import { BaseFormLabel } from "@/shared/ui/base-form-label";
import { BaseTextField } from "@/shared/ui/base-text-field";
import { PrefectureField } from "@/widgets/prefecture-field";
import { Stack } from "@mui/material";

export const LocationSelect = ({
  label,
  prefecture,
  city,
  onPrefectureChange,
  onCityChange,
}: {
  label: string;
  prefecture: string | undefined;
  city: string | undefined;
  onPrefectureChange: (prefecture: string | undefined) => void;
  onCityChange: (city: string) => void;
}) => (
  <Stack direction="row" spacing={2}>
    <BaseFormLabel label={`${label}(都道府県)`}>
      <PrefectureField
        value={prefecture}
        size="small"
        onChange={(v) => onPrefectureChange(v)}
      />
    </BaseFormLabel>
    <BaseFormLabel label={`${label}(市区町村)`}>
      <BaseTextField
        value={city}
        size="small"
        sx={{
          minWidth: 180,
        }}
        onChange={(v) => onCityChange(v.target.value)}
      />
    </BaseFormLabel>
  </Stack>
);
